import { render, staticRenderFns } from "./JointApplicantSelect.vue?vue&type=template&id=4792a5be&"
import script from "./JointApplicantSelect.vue?vue&type=script&lang=js&"
export * from "./JointApplicantSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports